import React from 'react';

export default function PageTransition({ children }) {
  return (
    <div className="transition-all duration-300 ease-in-out fade-in">
      {children}
    </div>
  );
}
